(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cards-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const tabEls = Array.from(document.querySelectorAll('.cards-tab'));
  const linkFor = (tab) => tab.querySelector('a');
  const idFrom = (a) => a?.getAttribute('href')?.slice(1);

  // Map sectionId -> { tab, link, section }
  const items = tabEls.map(tab => {
    const a = linkFor(tab);
    const id = idFrom(a);
    const section = id ? document.getElementById(id) : null;
    return section ? { id, tab, a, section } : null;
  }).filter(Boolean);

  if (!items.length) return;

  // --- Activate helper (runs only when active changes) ---
  let activeId = null;
  let raf = null;
  const tabsScroller = document.querySelector('.cards-tabs');

  function setActive(id) {
    if (!id || id === activeId) return;
    activeId = id;

    // Update classes
    items.forEach(({ id: sid, tab }) => {
      tab.classList.toggle('active', sid === id);
    });

    // Horizontally center the active tab once; avoid vertical scroll changes
    const activeTab = items.find(x => x.id === id)?.tab;
    if (activeTab && tabsScroller) {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        // Only scroll the horizontal tab container, not the entire page
        const tabRect = activeTab.getBoundingClientRect();
        const scrollerRect = tabsScroller.getBoundingClientRect();
        const scrollLeft = tabsScroller.scrollLeft;
        const tabOffsetLeft = tabRect.left - scrollerRect.left + scrollLeft;
        const tabCenter = tabOffsetLeft - (scrollerRect.width / 2) + (tabRect.width / 2);
        tabsScroller.scrollTo({ left: tabCenter, behavior: 'auto' });
      });
    }
  }

  // --- Observe sections crossing the center band of the viewport ---
  // This band is roughly the middle 40% of the viewport.
  const io = new IntersectionObserver((entries) => {
    // Choose the visible section with the greatest intersectionRatio
    let best = null;
    for (const e of entries) {
      if (!e.isIntersecting) continue;
      if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
    }
    if (best?.target?.id) setActive(best.target.id);
  }, {
    root: null,
    // Make the "active" band the middle by shrinking top/bottom
    rootMargin: '-30% 0px -30% 0px',
    threshold: Array.from({length: 11}, (_, i) => i / 10) // 0.0…1.0
  });

  items.forEach(({ section }) => io.observe(section));

  // --- Smooth scroll on click (account for sticky header) ---
  // If you have a sticky header, set its height here or read it dynamically:
  const stickyHeader = document.querySelector('[data-sticky-header], .shopify-section-header, header[sticky]');
  const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;

  items.forEach(({ a, id }) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const el = document.getElementById(id);
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // Initial sync (pick the first visible or the first item)
  setTimeout(() => {
    const firstVisible = items.find(({ section }) => {
      const r = section.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    });
    setActive(firstVisible?.id || items[0].id);
  }, 0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-secrets"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.open-popup').forEach(button => {
  button.addEventListener('click', function() {
    const url = this.getAttribute('data-url');

    fetch(url)
      .then(response => response.text())
      .then(html => {
        // Create a temporary DOM parser across a virtual element
        let parser = new DOMParser();
        let doc = parser.parseFromString(html, 'text/html');

        // Adjust selector to your blog article content container on full page template
        let articleContent = doc.querySelector('.content-for-layout'); 

        // Insert full article template content into popup
        document.getElementById('popup-html-content').innerHTML = articleContent ? articleContent.innerHTML : 'Content not found';

        // Show popup
        document.getElementById('blog-post-popup').classList.add('active');
      })
      .catch(err => {
        console.error('Failed to load blog post:', err);
      });
  });
});

// Close popup
document.querySelector('#blog-post-popup .close').addEventListener('click', () => {
  document.getElementById('blog-post-popup').classList.remove('active');
});

// Close popup when clicking outside content
window.addEventListener('click', (event) => {
  const modal = document.getElementById('blog-post-popup');
  if(event.target === modal){
    modal.classList.remove('active');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  const modals = document.querySelectorAll(".supplements-modal");
  const openModalButtons = document.querySelectorAll(".open-supplements-modal");
  const closeModalButtons = document.querySelectorAll(".close-supplements-modal");

  openModalButtons.forEach(button => {
    button.onclick = function() {
      modals.forEach(modal => {
        modal.classList.add("active");
      })
    };  
  });

  closeModalButtons.forEach(button => {
   button.onclick = function() {
      modals.forEach(modal => {
        modal.classList.remove("active");
      })
    };    
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
